'use client';

import { motion, useScroll, useTransform } from 'framer-motion';

export const NotchScrollAnimation = ({ children }: { children: React.ReactNode }) => {
  const { scrollY } = useScroll();

  const yPosition = useTransform(scrollY, [30, -30], [-30, -10]);
  const xPosition = useTransform(scrollY, [0, 200], ['5%', '-30%']);
  const scale = useTransform(scrollY, [0, 200], [0.7, 1]);

  return (
    <motion.div
      className='left-[35%] sm:left-[40%]'
      style={{
        position: 'fixed',
        transform: 'translateX(-50%)',
        y: yPosition,
        x: xPosition,
        scale: scale,
        color: 'white',
      }}
    >
      {children}
    </motion.div>
  );
};
